export const environment = {
  google_analytics_code: 'UA-121116087-1',
  production: true,
  showUserGuideByDefault: false,
  wsProxyUrl: 'wss://ws-development.clarity.estlanderpartners.com/psp/',
  showKYC: true,
};
